<div adaptToolbarContent
     *ngIf="isActivated">
    <button *ngIf="canConfigureTeam"
            adaptButtonIcon="add"
            [adaptBlockingClick]="addTeam"
            [unsubscribeOnDestroy]="false"
            data-test="add-team-button">Add team
    </button>

    <adapt-menu [items]="pageMenuItems"
                data-test="teams-actions-button"></adapt-menu>

</div>

@let teams = (displayTeams$ | async) ?? [];
@if (teams.length) {
    <adapt-organisation-explorer [selectedViewOption]="ViewOption.OrganisationMapTeams"
                                 [filterTeams]="filterForMyTeams"
                                 (loaded)="notifyActivated()"></adapt-organisation-explorer>
} @else {
    <adapt-call-to-action learnMoreUrl="https://support.adaptbydesign.com.au/teams">
        <adapt-call-to-action-title>Teams</adapt-call-to-action-title>
        <p>
            A team, in its simplest form, is a group of people working together toward common goals.
            In the adapt platform, teams are fundamental building blocks of your organisation, helping structure how people collaborate
            effectively.
        </p>
        @if (canConfigureTeam) {
            <button adaptCallToActionButton
                    adaptButtonIcon="add"
                    [unsubscribeOnDestroy]="false"
                    [adaptBlockingClick]="addTeam">
                Add team
            </button>
        }
    </adapt-call-to-action>
}
